import React, { useState } from 'react'

import { Button } from 'antd'
import { Form, Input, DatePicker } from 'formik-antd'

import { isNotValid, translateSymfonyErrorToFormik } from '../../../core/utils/form'

/* Form & Form Validation */
import * as Yup from 'yup'
import Moment from 'moment'

import ModalForm from '../../../core/components/form/modalForm'

import PropTypes from 'prop-types'

const propTypes = {
  buttonLabel: PropTypes.string,
  buttonType: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  fileRequired: PropTypes.bool
}

const defaultProps = {
  buttonLabel: 'Invoice',
  buttonType: 'primary',
  fileRequired: true
}

const validationSchemaWithFile = Yup.object().shape({
  date: Yup.string().required('Cannot be blank.'),
  number: Yup.string().required('Cannot be blank.'),
  file: Yup.mixed().required('Cannot be blank.')
})

const validationSchema = Yup.object().shape({
  date: Yup.string().required('Cannot be blank.'),
  number: Yup.string().required('Cannot be blank.')
})

function InvoiceButton (props) {
  const { buttonLabel, onUpload } = props
  const [modalVisible, setModalVisible] = useState(false)

  const defaultValue = {
    file: null,
    date: Moment(),
    amount: props.amountValue,
    number: props.defaultText ? props.defaultText : '',
    notes: null
  }

  const showModal = () => {
    setModalVisible(true)
  }

  const closeModal = () => setModalVisible(false)
  const onSubmit = (values, bag) => {
    const form = new FormData()
    const date = values.date == null ? null : Moment(values.date).format('YYYY-MM-DD')
    form.append('date', date)
    form.append('file', values.file)
    form.append('number', values.number)
    /* form.append("amount", values.amount); */

    if (values.notes) {
      form.append('notes', values.notes)
    }

    onUpload(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        closeModal()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  return (
    <>
      <Button type={props.buttonType} size='small' onClick={showModal}>
        {buttonLabel}
      </Button>

      {modalVisible && (
        <ModalForm
          title='Invoice'
          enableReinitialize
          initialValues={defaultValue}
          validationSchema={props.fileRequired ? validationSchemaWithFile : validationSchema}
          onSubmit={onSubmit}
          onCancel={closeModal}
          visible={modalVisible}
          render={({ isSubmitting, touched, errors, values, setFieldValue, setFieldTouched }) => (
            <>
              <Form.Item label='Date' name='date' hasFeedback showValidateSuccess required>
                <DatePicker name='date' format='YYYY-MM-DD' placeholder='Date' />
              </Form.Item>

              <Form.Item
                label='Number'
                name='number'
                hasFeedback
                showValidateSuccess
                required
              >
                <Input name='number' placeholder='Number' />
              </Form.Item>

              <Form.Item label='Amount' name='amount'>
                <Input name='amount' placeholder='Amount' suffix={props.amountType} disabled />
              </Form.Item>

              <Form.Item label='Invoice' name='file' hasFeedback required={props.fileRequired}>
                <input
                  name='file'
                  type='file'
                  onChange={(event) => {
                    setFieldValue('file', event.currentTarget.files[0])
                  }}
                />
              </Form.Item>

              <Form.Item label='Notes' name='notes'>
                <Input.TextArea name='notes' placeholder='Notes' />
              </Form.Item>
            </>
          )}
        />
      )}
    </>
  )
}

InvoiceButton.propTypes = propTypes
InvoiceButton.defaultProps = defaultProps

export default InvoiceButton
